function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useDrag } from "@use-gesture/react";
import styled from "styled-components";
import React, { memo, useCallback, useState } from "react";
import useSpring from "react-use/lib/useSpring";
import clamp from "astrid-helpers/src/clamp";
import map from "astrid-helpers/src/map";
import { color } from "../../../helpers/color";
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1nks4ce-0"
})(["position:relative;overflow:hidden;"]);
const Background = /*#__PURE__*/styled.div.withConfig({
  displayName: "Background",
  componentId: "sc-1nks4ce-1"
})(["display:flex;position:absolute;top:0;left:0;width:100%;height:100%;align-items:stretch;"]);
const Area = /*#__PURE__*/styled.div.withConfig({
  displayName: "Area",
  componentId: "sc-1nks4ce-2"
})(["flex:1;background:", ";"], color);
const Content = /*#__PURE__*/styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-1nks4ce-3"
})(["position:relative;"]);
const Swipe = /*#__PURE__*/memo(({
  x,
  right,
  left,
  swipeTarget,
  children,
  onClick,
  onChange
}) => {
  const [tempX, setTempX] = useState(x);
  const spring = useSpring(tempX, 170, 25);
  const onDrag = useDrag(useCallback(({
    tap,
    last,
    first,
    event,
    movement
  }) => {
    // Only trigger swipe if the target is child of swipeTarget
    if (swipeTarget?.current && !swipeTarget.current.contains(event.target)) {
      return;
    }
    event.stopPropagation();
    if (tap) {
      return onClick?.();
    }
    if (last) {
      if (x !== tempX && onChange) {
        setTempX(onChange(tempX));
      }
    } else if (!first) {
      let [x] = movement;
      if (!right && x > 0) x = 0;
      if (!left && x < 0) x = 0;
      const t = clamp(map(x, 0, x > 0 ? 200 : -200, 1, 0.5), 0.5, 1);
      setTempX(clamp(Math.round(x * t), -200, 200));
    }
  }, [left, onChange, onClick, right, tempX, x]), {
    filterTaps: true
  });
  return /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(Background, null, /*#__PURE__*/React.createElement(Area, {
    color: "negative"
  }), /*#__PURE__*/React.createElement(Area, {
    color: "default"
  })), /*#__PURE__*/React.createElement(Content, _extends({
    style: {
      transform: (right || left) && `translate3d(${Math.round(spring)}px, 0, 0)`
    }
  }, onDrag()), children));
});
export default Swipe;
//# sourceMappingURL=index.js.map